<template>
    <v-card flat>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="data.name"
                        :label="$t('learn_goal_control.name')"
                        :error-messages="formError(errors, 'name')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="data.number"
                        :label="$t('learn_goal_control.number')"
                        :error-messages="formError(errors, 'number')"
                    />
                </v-col>
                <v-col md="6">
                    <v-text-field
                        type="text"
                        v-model="data.zip"
                        :label="$t('learn_goal_control.zip')"
                        :error-messages="formError(errors, 'zip')"
                    />
                </v-col>
                <v-col md="6">
                    <v-text-field
                        type="text"
                        v-model="data.city"
                        :label="$t('learn_goal_control.city')"
                        :error-messages="formError(errors, 'city')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-textarea
                        type="text"
                        v-model="data.address"
                        :label="$t('learn_goal_control.address')"
                        :error-messages="formError(errors, 'address')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="data.phone"
                        :label="$t('learn_goal_control.phone')"
                        :error-messages="formError(errors, 'phone')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="data.fax"
                        :label="$t('learn_goal_control.fax')"
                        :error-messages="formError(errors, 'fax')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="data.email"
                        :label="$t('learn_goal_control.email')"
                        :error-messages="formError(errors, 'email')"
                    />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>

export default {
    name: 'LearnGoalControlInformation',
    props: {
        data: {
            type: Object,
            default: () => ({
                name: '',
                roles: [],
            }),
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
